import Layout from '@/layout'

const asyncPurchaseRoutes = {
  path: '/purchase/manager',
  component: Layout,
  redirect: 'noRedirect',
  name: '采购管理',
  funcPerms: 'purchase:manager',
  meta: {
    title: '采购管理',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/manager/apply/purchase_10',
      component: () => import('@/views/purchase/purchasePlan/myProcess/index.vue'),
      name: '我的采购申请',
      funcPerms: 'purchase:manager:apply:my',
      meta: {
        title: '我的采购申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/detail',
      component: () => import('@/views/purchase/purchasePlan/detail/index.vue'),
      name: '明细填报',
      funcPerms: 'purchase:manager:apply:detail',
      meta: {
        title: '明细填报',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/detail/add',
      component: () => import('@/views/purchase/purchasePlan/detail/add.vue'),
      name: 'ConsumablesPurchaseApplicationAdd',
      hidden: true,
      meta: {
        title: '采购明细填报',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/detail/edit',
      component: () => import('@/views/purchase/purchasePlan/detail/add.vue'),
      name: 'ConsumablesPurchaseApplicationEdit',
      hidden: true,
      meta: {
        title: '采购明细填报',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/detail/view',
      component: () => import('@/views/purchase/purchasePlan/detail/view.vue'),
      name: 'consumablesPurchaseApplication-view',
      hidden: true,
      meta: {
        title: '查看采购申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/pass/purchase_10',
      component: () => import('@/views/purchase/purchasePlan/todo/index.vue'),
      name: '我未审批的采购',
      funcPerms: 'purchase:manager:apply:my:todo',
      meta: {
        title: '我未审批的采购',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/my/finished/purchase_10',
      component: () => import('@/views/purchase/purchasePlan/finished/index.vue'),
      name: '我已审批的采购',
      funcPerms: 'purchase:manager:apply:my:finished',
      meta: {
        title: '我已审批的采购',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/list',
      component: () => import('@/views/purchase/purchasePlan/list/index.vue'),
      name: '采购申请列表',
      funcPerms: 'purchase:manager:apply:list:all',
      meta: {
        title: '采购列表',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/summary',
      component: () => import('@/views/purchase/purchaseSummary/index.vue'),
      funcPerms: 'purchase:manager:summary',
      name: 'purchaseSummary',
      meta: {
        title: '汇总申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/send/index',
      component: () => import('@/views/purchase/purchasePlan/myProcess/send/index.vue'),
      name: '发起采购申请',
      hidden: true,
      meta: {
        title: '发起采购申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/todo',
      component: () => import('@/views/purchase/purchasePlan/todo/detail/index.vue'),
      name: '采购审批',
      hidden: true,
      meta: {
        title: '采购审批',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/manager/apply/detail/index',
      component: () => import('@/views/purchase/purchasePlan/myProcess/detail/index.vue'),
      name: '采购详情',
      hidden: true,
      meta: {
        title: '采购详情',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncPurchaseRoutes
